import {IElasticEventData, IStructuredLogger} from '../../../common/interfaces/structured-logging-service-interface';
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";

export enum OrbitUserFlowAnalyticsCategory {
  Navigation = 'Navigation',
  PWA = 'PWA',
  Search = 'Search',
}

export enum OrbitUserFlowAnalyticsLabel {
  AppHeader = "AppHeader",
  HomePageHeaderArenas = "HomePageHeaderArenas",
  NavigationMenu = 'NavMenu',
  UserArea = 'UserArea',
  BottomNavigationBar = 'BottomNavBar',
  ShowMore = 'Show_More'
}

export type OrbitUserFlowAnalyticsAction = MenuItemKey
                                           | string
                                           | 'myAccountButton' | 'withdrawButton' | 'depositButton'
                                           | 'Entry';

export enum OrbitMarketingEventAnalyticsCategory {
  Conversion = 'Conversion',
  Communications = 'Communications',
}

export enum OrbitMarketingEventAnalyticsLabel {
  PreGamePopUp = 'PreGamePopUp',
  DemoRegPopup = 'DemoRegPopup',
  VideoPlayback = 'VIDEO_PLAYBACK',
  Error = 'ERROR',
  Click = 'CLICK',
}

export type OrbitMarketingEventAnalyticsAction = MenuItemKey
                                           | string
                                           | 'Play' | 'Show'
                                           | 'IN_VIEW' | 'LIMIT_REACH' | 'AUTOPLAY' | 'PLAY' | 'PLAY_GAME' | 'SOUND_CLICK'
                                           | 'Open_Floating_Button' | 'Close_Floating_Button' | 'View_Floating_Button';

export enum OrbitAIFeatureAnalyticsCategory {
  AIArenaIconsDisplayed = 'AI_ArenaIconsDisplayed',
  CorrelatedGamePopUp = 'CorrelatedGamePopUp'
}

export type OrbitAIFeatureAnalyticsAction = MenuItemKey
                                           | string
                                           | 'Game_Unavailable'


export interface ISendElasticEventOptions  {
  eventType: string;
  category: string;
  action: string;
  label?: string;
  value?: string;
  customData?: object;
  appID?: string;
}

export interface IAnalyticsService {
  sendAnalytics(category: string, action?: string, label?: string, value?: any, omitStructuredLogger?: boolean): void;
  sendTechnicalEvent(action: string, label?: string, value?: any): void;
  sendElasticInfoEvent(options: ISendElasticEventOptions, sendToDWH?: boolean): void;
  sendOrbitUserFlowEvent(category: string | OrbitUserFlowAnalyticsCategory, action: OrbitUserFlowAnalyticsAction, label?: string | OrbitUserFlowAnalyticsLabel, value?: any): void;
  sendOrbitMarketingEvent(category: string | OrbitMarketingEventAnalyticsCategory, action: OrbitMarketingEventAnalyticsAction, label?: string | OrbitMarketingEventAnalyticsLabel, value?: any): void;
  sendOrbitAIFeatureEvent(category: string | OrbitAIFeatureAnalyticsCategory, action: OrbitAIFeatureAnalyticsAction, label?: string, value?: any): void;
  getLogger(eventData?: IElasticEventData): IStructuredLogger;
  getGoogleClientID(): string;
}



